import { render, staticRenderFns } from "./tnc.vue?vue&type=template&id=572318e9&scoped=true&"
import script from "./tnc.vue?vue&type=script&lang=js&"
export * from "./tnc.vue?vue&type=script&lang=js&"
import style0 from "./tnc.vue?vue&type=style&index=0&id=572318e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572318e9",
  null
  
)

export default component.exports